import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OktaAuthService } from '@okta/okta-angular';
import { FclLoginService } from './fcllogin.service';
import { NavService } from './nav.service';

@Injectable({
  providedIn: 'root'
})
export class FscAuthGuard implements CanActivate {
  constructor(
    private navSvc: NavService,
    private okta: OktaAuthService, private router: Router, private fclLoginService: FclLoginService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    /** This hack was introduced to fix CORS issue from .fedex.com & .logisitics.fedex.com */
    this.navSvc.deleteAllCookies();
    if (this.fclLoginService.getUserType() === 'I' || this.fclLoginService.getUserType() === 'T') {
      const authenticated = await this.okta.isAuthenticated();
      if (authenticated) {
        return true;
      } else {
        return false;
      }
    } else if (this.fclLoginService.getUserType() === 'E') {
      return this.fclLoginService.isUserLoggedIn;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }
}
